import { transformNullishFromData } from "@/utils/transforms";
// import decryptData from "@/utils/removeEncryption";
// import moment from "moment";

export const GET_DEFAULT_DATA = () => ({
  reOpeningDeadlineData: {
    competence: null,
    justification: null,
    userId: null,
    suppliesTypesId: null,
    reopeningStatusId: null
  }
});

export default {
  state: {
    default: {
      formulaData: {
        id: 0,
        competence: null,
        instituitionName: null,
        instituitionId: 0,
        userName: null,
        userId: 0,
        sendDate: null
      },
      formulaOne: {
        id: 0,
        numberExposedChildren: null,
        balanceCurrentMonth: null,
        entryCurrentMonth: null,
        quantityDistributed: null,
        quantityRearranged: null,
        totalQuantity: 0,
        finalBalance: 0,
        localDistributed: null,
        regionalDistributed: null,
        cityDistributed: null,
        unitDistributed: 0,
        localRearranged: null,
        regionalRearranged: null,
        cityRearranged: null,
        unitRearranged: 0,
        observation: null,
        totalNumberChildrenServed: null,
        totalNumberChildrenExposed: 0,
        cansQuantity: null,
        formulaTypeId: 0,
        outputCurrentMonth: true,
        neededNextMonth: true,
      },
      formulaTwo: {
        id: 0,
        numberExposedChildren: null,
        balanceCurrentMonth: null,
        entryCurrentMonth: null,
        quantityDistributed: null,
        quantityRearranged: null,
        totalQuantity: 0,
        finalBalance: 0,
        localDistributed: null,
        regionalDistributed: null,
        cityDistributed: null,
        unitDistributed: 0,
        localRearranged: null,
        regionalRearranged: null,
        cityRearranged: null,
        unitRearranged: 0,
        observation: null,
        totalNumberChildrenServed: null,
        totalNumberChildrenExposed: 0,
        cansQuantity: null,
        formulaTypeId: 0,
        outputCurrentMonth: true,
        neededNextMonth: true,
      },
      reopenRequestData: {
        competence: null ,
        justification: null ,
        userId: 0 ,
        suppliesTypesId: 0 ,
        reopeningStatusId: 0,
        outputCurrentMonth: true,
        neededNextMonth: true,
      },
      reopeningEvaluationData: {
        id: null,
        denialReason: null,
        status: null,
      },
      reopeningDeadlineData: {
        competence: null,
        justification: null,
        userId: null,
        suppliesTypesId: null,
        reopeningStatusId: null
      },
    },
    data: {
      formulaData: {},
      formulaOne: {},
      formulaTwo: {},
      reopenRequestData: {},
      reopeningEvaluationData: {},
    }
  },

  getters: {
    getRequestData(state) {
      return state.data;
    },
    getDefaultRequestData(state) {
      return state.default;
    },
    getReopenRequestData(state) {
      return state.default.reopeningDeadlineData;
    }
  },

  mutations: {
    resetOrPersistFormulaData(state, data) {
      state.data.formulaData = transformNullishFromData(data);
    },
    resetOrPersistFormulaOneData(state, data) {
      state.data.formulaOne = transformNullishFromData(data);
    },
    resetOrPersistFormulaTwoData(state, data) {
      state.data.formulaTwo = transformNullishFromData(data);
    },
    resetReopenRequestData(state, data) {
      state.default.reopenRequestData = transformNullishFromData(data);
    },
    resetReopeningEvaluationData(state, data) {
      state.default.reopeningEvaluationData = transformNullishFromData(data);
    },
    resetReopeningDeadlineData(state, data) {
      state.default.reopeningDeadlineData = GET_DEFAULT_DATA(data).reOpeningDeadlineData;
    },
   
  },

  actions: {
    changeFormulaData(context, info) {
      context.commit("resetOrPersistFormulaData", info);
    },
    changeFormulaOneData(context, info) {
      context.commit("resetOrPersistFormulaOneData", info);
    },
    changeFormulaTwoData( context, info) {
      context.commit("resetOrPersistFormulaTwoData", info);
    },
    changeReopenRequestData(context, info) {
      context.commit("resetReopenRequestData", info);
    }
  },
};